export default function JensenBeachHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden bg-[#1A365D]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Jensen%20Beach%20Florida%20Hutchinson%20Island%20coastline%20at%20golden%20hour%2C%20pristine%20sandy%20beach%20meeting%20turquoise%20Atlantic%20Ocean%20waters%2C%20lush%20tropical%20vegetation%2C%20quaint%20coastal%20homes%2C%20warm%20sunset%20light%20casting%20golden%20glow%20over%20the%20shoreline%2C%20laid-back%20Old%20Florida%20beach%20town%20atmosphere%2C%20soft%20coral%20and%20deep%20teal%20tones%2C%20professional%20real%20estate%20photography%20style&width=1600&height=900&seq=jensenbeach-hero&orientation=landscape"
          alt="Jensen Beach Florida Hutchinson Island coastline and beach town"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A365D]/80 via-[#1A365D]/60 to-[#1A365D]/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center pt-20">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 backdrop-blur-sm border border-[#F6C344]/30 rounded-full px-4 py-2 mb-6">
          <i className="ri-shield-check-line text-[#F6C344] text-sm"></i>
          <span className="text-[#F6C344] text-xs font-bold uppercase tracking-wider">Registered U.S. Department of State Courier</span>
        </div>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Expedited Passport Services in <span className="text-[#F6C344]">Jensen Beach, FL</span>
        </h1>

        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-4 leading-relaxed">
          Emergency and expedited passport processing for Jensen Beach and Hutchinson Island residents, anglers, beach lovers, and Treasure Coast travelers — as fast as <strong className="text-white">24 hours</strong>.
        </p>

        <p className="text-white/60 text-base max-w-xl mx-auto mb-10 leading-relaxed">
          Serving Jensen Beach, Stuart, Palm City, Hobe Sound, and coastal Martin County. No drive to Miami. Start online and ship overnight.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white font-semibold text-base px-6 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> 877-253-0084
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: "ri-award-line", text: "A+ BBB Rating" },
            { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
            { icon: "ri-time-line", text: "20+ Years Experience" },
            { icon: "ri-customer-service-2-line", text: "Live Human Support" },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/60 text-sm">
              <i className={`${badge.icon} text-[#F6C344]`}></i>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}